import { createAsyncThunk } from '@reduxjs/toolkit';
import { GivePlan, TopupBalance } from '../domain/interfaces/billing-input';

import { ResponseGivePlan, ResponseTopupBalance } from '../domain/interfaces/billing-response';
import plans from '../domain/resources/plans';

const PREFIX = 'organizers';

export const topupBalance = createAsyncThunk<ResponseTopupBalance, TopupBalance>(
  `${PREFIX}/topupBalance`,
  async (payload, { rejectWithValue }) => {
    try {
      return await plans.topupBalance(payload);
    } catch (error) {
      console.error(`${PREFIX}/topupBalance error:`, error);

      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      return rejectWithValue(message);
    }
  },
);

export const givePlan = createAsyncThunk<ResponseGivePlan, GivePlan>(`${PREFIX}/givePlan`, async (payload, { rejectWithValue }) => {
  try {
    const result = await plans.givePlan(payload);
    if (typeof result === 'string') {
      console.error({ event: 'givePlan', message: result, data: { payload } });
      return rejectWithValue(result);
    }

    return result;
  } catch (error) {
    console.error(`${PREFIX}/givePlan error:`, error);

    let message;
    if (error instanceof Error) message = error.message;
    else message = String(error);
    return rejectWithValue(message);
  }
});
